import { LeaseDuration, LeaseDuration_values } from '@zg-rentals/ts-rental-manager-api-client';

/** `/details` stores the short code; the edit endpoint takes the enum. */
export const LEASE_DURATION_CODE: Record<LeaseDuration, string> = {
  [LeaseDuration.ONE_MONTH]: '1mo',
  [LeaseDuration.SIX_MONTH]: '6mo',
  [LeaseDuration.ONE_YEAR]: '1y',
  [LeaseDuration.RENT_TO_OWN]: 'r2o',
  [LeaseDuration.SUBLET_TEMPORARY]: 'sub',
};

export const LEASE_DURATION: Record<string, LeaseDuration> = Object.fromEntries(
  LeaseDuration_values.map((leaseDuration) => [LEASE_DURATION_CODE[leaseDuration], leaseDuration]),
);
